import _map from 'lodash/map';
import _concat from 'lodash/concat';
import _cloneDeep from 'lodash/cloneDeep';

import { v4 as uuidv4 } from 'uuid';

import initialState from './initialState';
import actionType from './actionTypes';

const sourceConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ALL_SOURCE_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                sourceConfigurations: action.payload,
                sourceNamesForSelectionBox: _map(action.payload, (data) => ({
                    ...data,
                    label: data.source_name,
                    value: data.source_name,
                })),
                gridSourceConfigurations: {
                    fielddata: initialState.gridSourceConfigurations.fielddata,
                    instances: _map(action.payload, (config) => ({
                        ...config,
                        id: uuidv4(),
                        filing_date: null,
                        // created_date : moment(config.created_date, "YYYY MM DD")
                    })),
                },
                sourceNames: _map(action.payload, 'source_name'),
            };
        }
        case actionType.GET_SOURCE_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                sourceConfig: {},
            };
        }
        case actionType.GET_SOURCE_FIELD_SETTINGS_SUCCESS: {
            const { sourceFieldsSettings, unMappedDataDictionaries, mappedDataDictionaries, sourceJSONConfigs } = action.payload;
            return {
                ...state,
                sourceFieldsSettings,
                unMappedDataDictionaries,
                mappedDataDictionaries,
                sourceJSONConfigs,
            };
        }

        case actionType.GET_SOURCE_COLUMNS_SUCCESS:
            return {
                ...state,
                sourceColumns: action.payload,
            };
        case actionType.GET_TARGET_COLUMNS_SUCCESS:
            return {
                ...state,
                targetColumns: action.payload,
            };

        case actionType.UPDATE_SOURCE_AND_TARGET_COLUMNS_SUCCESS:
            return {
                ...state,
                targetColumns: action.payload.targetColumns,
                sourceColumns: action.payload.sourceColumns,
            };
        case actionType.GET_ALL_SOURCE_CONFIGURATION_FOR_SIDEBAR_SUCCESS:
            return {
                ...state,
                sourceConfigurationsForSideBar: action.payload,
            };

        case actionType.SET_SOURCE_DICTIONARIES_FOR_VIEW_CONFIG:
            return {
                ...state,
                viewSourceDictionaries: _cloneDeep(_concat(action.payload, state.viewSourceDictionaries)),
            };

        case actionType.RESET_SOURCE_DICTIONARIES_FOR_VIEW_CONFIG:
            return {
                ...state,
                viewSourceDictionaries: action.payload,
            };
        case actionType.GET_LOOKUP_SOURCE_DD:
            return {
                ...state,
                lookUpSourceDataDictionaries: action.payload,
            };
        case actionType.ADD_API_LOGGERS: {
            const newLoggers = _cloneDeep(state.apiLoggers);
            newLoggers.push(action.payload);
            return {
                ...state,
                apiLoggers: newLoggers,
            };
        }
        case actionType.GET_ALL_SOURCE_IMPORT_COMMENTS:
            return {
                ...state,
                sourceImportComments: action.payload,
            };
        case actionType.GET_ALL_SOURCE_SETTINGS:
            return {
                ...state,
                importSourceSettings: action.payload,
            };
        default:
            return state;
    }
};

export default sourceConfigurationReducer;
